// Mise en page adaptative (phase 2026-10-widget-adaptatif) : carte unique,
// en-tête léger, [calendrier | créneaux] en mode large, panneaux successifs en
// mode étroit, formulaire plein cadre avec barre d'actions. Le mode est porté
// par data-rdv-mode (mesuré sur le conteneur par index.js, seuil 600 px).
export const adaptiveStyles = `
.rdv-root .rdv-card {
  background: var(--rdv-surface);
  border: 1px solid var(--rdv-border);
  border-radius: var(--rdv-radius);
  box-shadow: var(--rdv-shadow);
  overflow: hidden;
}

/* --- En-tête -------------------------------------------------------------- */
.rdv-root .rdv-head {
  align-items: center;
  border-bottom: 1px solid var(--rdv-border);
  display: flex;
  gap: 14px;
  padding: 18px 24px;
}

.rdv-root .rdv-head-logo {
  border-radius: 50%;
  flex: none;
  height: 48px;
  overflow: hidden;
  width: 48px;
}

.rdv-root .rdv-head-logo img {
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.rdv-root .rdv-head-text {
  min-width: 0;
}

.rdv-root .rdv-head-brand {
  color: var(--rdv-muted);
  font-size: 0.82rem;
  font-weight: 700;
  margin: 0 0 2px;
}

.rdv-root .rdv-head-title {
  font-family: var(--rdv-font-heading);
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.25;
  margin: 0;
}

.rdv-root .rdv-head-meta {
  color: var(--rdv-muted);
  font-size: 0.9rem;
  margin: 2px 0 0;
}

/* --- Message d'état -------------------------------------------------------- */
.rdv-root .rdv-status-wrap {
  padding: 14px 24px 0;
}

/* --- Choix : calendrier / créneaux ---------------------------------------- */
.rdv-root .rdv-pick {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.rdv-root[data-rdv-mode="wide"] .rdv-pick {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
}

.rdv-root .rdv-col {
  min-width: 0;
  padding: 20px 24px 24px;
}

.rdv-root[data-rdv-mode="wide"] .rdv-col-slots {
  border-left: 1px solid var(--rdv-border);
  display: flex;
  flex-direction: column;
}

.rdv-root .rdv-col-title {
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.3;
  margin: 0 0 12px;
}

.rdv-root .rdv-col-sub {
  color: var(--rdv-muted);
  font-size: 0.92rem;
  margin: -6px 0 12px;
}

.rdv-root .rdv-col-sub strong {
  color: var(--rdv-text);
}

.rdv-root .rdv-col-slots .rdv-tz {
  margin: 0 0 14px;
}

.rdv-root .rdv-col-slots .rdv-tz-label {
  font-size: 0.72rem;
}

.rdv-root .rdv-col-slots .rdv-tz-select {
  font-size: 0.92rem;
  min-height: 40px;
  padding: 6px 10px;
}

.rdv-root .rdv-col-slots .rdv-slot-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Mode large : liste défilante, hauteur alignée sur le calendrier. */
.rdv-root[data-rdv-mode="wide"] .rdv-col-slots .rdv-slot-list {
  flex: 1;
  max-height: 340px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 2px 6px 2px 2px;
}

.rdv-root .rdv-col-slots .rdv-slot-button {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  gap: 2px;
  justify-content: center;
  min-height: 48px;
  width: 100%;
}

.rdv-root .rdv-slot-time {
  font-size: 1rem;
}

.rdv-root .rdv-slots-placeholder,
.rdv-root .rdv-empty-card {
  margin: 0;
}

/* Retour (mode étroit, panneau créneaux) */
.rdv-root .rdv-back {
  align-items: center;
  appearance: none;
  background: none;
  border: 0;
  color: var(--rdv-accent);
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-weight: 700;
  gap: 6px;
  margin: -6px 0 6px -4px;
  min-height: 44px;
  padding: 0 4px;
}

.rdv-root .rdv-back::before {
  content: "‹";
  font-size: 1.3em;
  line-height: 1;
}

.rdv-root .rdv-back:focus-visible,
.rdv-root .rdv-link:focus-visible {
  border-radius: 4px;
  outline: 2px solid var(--rdv-focus);
  outline-offset: 2px;
}

/* --- Formulaire plein cadre ----------------------------------------------- */
.rdv-root .rdv-details {
  padding: 22px 24px 0;
}

.rdv-root .rdv-details-title {
  font-family: var(--rdv-font-heading);
  font-size: 1.2rem;
  font-weight: 800;
  margin: 0 0 6px;
}

.rdv-root .rdv-details-recap {
  align-items: baseline;
  color: var(--rdv-muted);
  display: flex;
  flex-wrap: wrap;
  font-weight: 700;
  gap: 4px 10px;
  margin: 0 0 18px;
}

.rdv-root .rdv-link {
  appearance: none;
  background: none;
  border: 0;
  color: var(--rdv-accent);
  cursor: pointer;
  font: inherit;
  font-weight: 700;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.rdv-root .rdv-details .rdv-form {
  display: grid;
  gap: 14px;
}

.rdv-root .rdv-footer-bar {
  align-items: center;
  background: var(--rdv-panel);
  border-top: 1px solid var(--rdv-border);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin: 8px -24px 0;
  padding: 14px 24px;
}

.rdv-root .rdv-footer-bar .rdv-submit {
  flex: 0 1 auto;
}

.rdv-root[data-rdv-mode="narrow"] .rdv-footer-bar .rdv-submit {
  flex: 1;
}

/* --- Confirmation plein cadre --------------------------------------------- */
.rdv-root .rdv-confirmation .rdv-title {
  font-family: var(--rdv-font-heading);
}

.rdv-root .rdv-card > .rdv-confirmation {
  margin: 0;
  padding: 24px;
}

/* --- Petits conteneurs ----------------------------------------------------- */
@container rdv (max-width: 420px) {
  .rdv-root .rdv-head,
  .rdv-root .rdv-col,
  .rdv-root .rdv-details {
    padding-left: 16px;
    padding-right: 16px;
  }

  .rdv-root .rdv-status-wrap {
    padding-left: 16px;
    padding-right: 16px;
  }

  .rdv-root .rdv-footer-bar {
    margin-left: -16px;
    margin-right: -16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .rdv-root .rdv-card > .rdv-confirmation {
    padding: 18px 16px;
  }

  /* Calendrier : chaque pixel compte pour des jours assez larges au doigt. */
  .rdv-root .rdv-col-calendar {
    padding-left: 10px;
    padding-right: 10px;
  }

  .rdv-root .rdv-col-calendar .rdv-col-title {
    padding: 0 6px;
  }

  .rdv-root .rdv-col-calendar .rdv-calendar-shell {
    padding: 6px 2px;
  }

  .rdv-root .dayContainer {
    gap: 2px;
  }
}
`;
